import PropTypes from 'prop-types';
import React from 'react';
import GenericFormItem from '../GenericFormItem';

const DateField = function DateField(props) {
  const {
    val,
    label,
  } = props;
  return (
    <GenericFormItem label={label}>
      {val}
    </GenericFormItem>
  );
};

DateField.propTypes = {
  val: PropTypes.string,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
};

export default DateField;



// WEBPACK FOOTER //
// ./src/components/FormConfigs/DateField.js